/** Client-side export details card — mirrors backend _export_details. */

function narrationText(rendered, project) {
  const parts = (rendered?.elements || [])
    .map((el) => String(el.narration || el.content || '').trim())
    .filter(Boolean);
  if (parts.length) return parts.join(' ');
  return String(project?.script?.full_narration || '');
}

export function buildExportDetails(project, segments = []) {
  const rendered = project?.rendered_timeline || {};
  const editor = project?.editor || {};
  const fps = Number(rendered.fps) || 30;
  const dur = Number(rendered.total_duration) || 0;
  const blockCount = (segments || []).reduce((n, s) => n + (s.blocks?.length || 0), 0);
  const narr = narrationText(rendered, project);
  const manifest = rendered.frame_manifest || {};
  const reuseTts = Boolean(
    project?.narration_audio_url
    && project?.narration_hash
    && project.narration_hash === project?.narration_hash,
  );

  return {
    width: Number(rendered.width) || 1280,
    height: Number(rendered.height) || 720,
    fps,
    total_duration: dur,
    total_frames: Math.max(1, Math.ceil(dur * fps)),
    scene_count: segments?.length || (rendered.scenes?.length || 0),
    block_count: blockCount,
    manifest_sampled_frames: manifest.sampled_frame_count,
    manifest_stride: manifest.stride,
    lifecycle_event_count: (manifest.lifecycle_events || []).length,
    narration_char_count: narr.length,
    narration_hash: project?.narration_hash || null,
    reuse_narration_audio: reuseTts && Boolean(project?.narration_audio_url),
    preview_status: editor.preview_status || 'draft',
    confirmed_at: editor.confirmed_at || null,
    has_final_video: Boolean(project?.final_video_url),
  };
}
